let resumeData = {
  name: "Isuru Rajapakshe",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://linkedin.com/in/isuru-p-rajapakshe/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/IsuruPabasara",
      className: "fa fa-github",
    },
    {
      name: "twitter",
      url: "https://twitter.com/IsuruRaj/",
      className: "fa fa-twitter",
    },
  ],
  email: "rmisur@gmail.com",
  education: [
    {
      UniversityName: "University of Moratuwa, Sri Lanka",
      specialization:
        "BSc Engineering in Electronic and Telecommunication Engineering",
      MonthOfPassing: "Aug",
      YearOfPassing: "2021",
      Achievements: [
        "Second Class (Upper Division) Honors with a CGPA of 3.57 out of 4.2",
        "Dean's List Placements - Semesters 1, 6, 7, 8",
      ],
    },
  ],
  work: [
    {
      CompanyName: "Insync Information Technologies, Colombo, Sri Lanka",
      specialization: "Software Engineer",
      MonthOfStarting: "Jul",
      YearOfStarting: "2021",
      MonthOfLeaving: "Jul",
      YearOfLeaving: "2022",
    },
    {
      CompanyName: "Lanka Electronics, Minuwangoda, Sri Lanka",
      specialization: "Electronic engineer intern",
      MonthOfStarting: "Jun",
      YearOfStarting: "2019",
      MonthOfLeaving: "Dec",
      YearOfLeaving: "2019",
    },
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "React JS",
      level: 90,
    },
    {
      skillname: "CSS",
      level: 71,
    },
    {
      skillname: "Javascript",
      level: 80,
    },
    {
      skillname: "Python",
      level: 60,
    },
    {
      skillname: "C#",
      level: 80,
    },
    {
      skillname: "C++(Arduino)",
      level: 80,
    },
  ],
  portfolio: [
    {
      name: "Non-Intrusive Power Monitor",
      id: "fyp",
      shortDescription: "2020 Feb. - 2021 Jul.",
      description:
        "This project was done by me and three other team members. Our focus was to develop an accurate power monitor with minimal invasion and real-time remote access which will help reduce electricity wastage in a household. We were able to build a prototype for the project using non-intrusive load monitoring(NILM). We used a clamp ammeter and a voltmeter to measure the instantaneous current and voltage of the main power line to a house and fed this data into a machine-learning model to deduce the power usage of appliances currently used in the house. These deductions can then be viewed by a person remotely real-time using a web interface. I built the web interface using react and hosted it using firebase and also contributed to the circuit design. We experimented with several machine-learning models and were able to outperform sate of the art in regards to real-time capability.",
      github: "https://github.com/IsuruPabasara/FYP-Website.git",
      report: "reports/fyp.pdf",
      video: "https://www.youtube.com/watch?v=IKLFPIjkCOc",
      website: "https://elecmoni.web.app",
      img1url: "images/portfolio/fyp-1.png",
      img2url: "images/portfolio/fyp-2.png",
    },
    {
      name: "LE Robot Software Package",
      id: "lerobot",
      shortDescription: "2019 Jun. - 2019 Sep.",
      description:
        "This was my first assigned project as an engineering trainee at Lanka Electronics Pvt. Ltd. My assigned task was to improve functionality of a software package. The purpose of the software package is to use a 6 degree of freedom to perform welding funtions defined by a user. The package was written in written in C# and I had to develop it's code such that it is capable of generating jerks to perform constant velocity motion with a 6 degree-of-freedom robot arm. After I completed the calculation, I then had to to simulate this motion inside the software by developing an animation tool. After completing this task, me and my supervisor used the generated jerks to test the motion with a real robot arm. We used the software to generate jerks for a path that we wanted and used a HMI to transfer these jerks to the motors in the robot. We were able to achieve about 1% error in its path.",
      report: "reports/lerobot.pdf",
      img1url: "images/portfolio/lerobot-1.png",
      img2url: "images/portfolio/lerobot-2.png",
    },
    {
      name: "Low Cost Human Machine Interface",
      id: "hmi",
      shortDescription: "2019 Sep. - 2019 Dec.",
      description:
        "This was my second assigned project as an engineering trainee at Lanka Electronics Pvt. Ltd. My task was to design and implement a low cost human machine interface. It's function was to communicate with a 6 degree-of-freedom robot arm to perform a welding function. I used a TFT LCD touchscreen and a atmega 128 microcontroller for the HMI. I then developed software using C that will run on the HMI to recieve user commands. The end product had a screen lag but apart from that, performed well in comparision to the high cost HMI in the company.",
      report: "reports/lerobot.pdf",
      img1url: "images/portfolio/hmi-1.jpeg",
      img2url: "images/portfolio/hmi-2.jpg",
    },
    {
      name: "Ambient Temperature and Humidity Controller for Orchids",
      id: "orchid",
      shortDescription: "2019 Apr. - 2019 May",
      description:
        "This project was done by a team of 10 students. Dendrobium orchids make a large portion of flower exports in Sri Lanka and we wanted to help the planters by giving them a low cost solution to the difficulties faced with varying enviorenmental conditions. We wanted to develop a system that can automatically control the  ambient temperature, ambient humidity, and lighting while automating irrigation system and fertilization process in the plantation. Our main focus was partially enclosed Dendrobium plantations. I contributed to the software writing and desgined the enclosures for the system circuits. We were able to develop a system that use humidifiers, sprinklers and solenoid valves to control ambient humidity and irrigate and fertilize the plantation. The lighting and temperature issue was partially solved by using 60% shade nets because other solutions were too costly to be of help to farmers.",
      github: "https://github.com/Mevan1996/AutomatedGreenHouse.git",
      report: "reports/orchid.pdf",
      img1url: "images/portfolio/orchid-1.jpeg",
      img2url: "images/portfolio/orchid-2.png",
    },
    {
      name: "Hot Plate Temperature Controller",
      id: "hotplate",
      shortDescription: "2018 Aug.",
      description:
        "This project was done by a team of four. The aim of the project was to build a temperature controller for a open coil hot plate so as to prevent overheating and energy wastage. We designed the circuit using triacs and PT100 sensor to suit the Sri Lankan current supply. I helped design the circuit and I designed the eclosure using solidworks.",
      report: "reports/hotplate.pdf",
      img1url: "images/portfolio/hotplate-1.png",
      img2url: "images/portfolio/hotplate-2.png",
    },
    {
      name: "CRUD Web App Using MERN Stack",
      id: "crud",
      shortDescription: "2021 Jun.",
      description:
        "This was a self-initiated project done to get fammiliar with the MERN stack. I was able to build a full-stack application that utilized JWT authentication for user handling, material-ui for styling and reducers for front-end data handling.",
      github: "https://github.com/IsuruPabasara/CRUD-with-MERN.git",
      img1url: "images/portfolio/crud-1.png",
      img2url: "images/portfolio/crud-2.png",
    },
    {
      name: "Line Following and Metal Collecting Robot",
      id: "arduinorobot",
      shortDescription: "2018 Mar",
      description:
        "This project was done with a team of four members for a competition. We had to design and implement a robot that can follow a strip on a contrasting background who can then collect metal coins and climb up a steep ramp to get to the finishing line. I developed the code for the robot. The robot callibrated it's sensors to ambient lighting and used magentic strips to collect coins. Our team became the runners-up in the competition.",
      img1url: "images/portfolio/arduinorobot-1.jpg",
    },
    {
      name: "Single Page Restaurant Web Application",
      id: "react",
      shortDescription: "2020 May",
      description:
        "This was a project I had to complete as a part of the Coursera course 'Front-End web development with React'. I built a restaurant app that showed the different dishes in the restaurant, restaurant details, location, contact information and a feedback form for customers. I got fammiliraized with React concepts like class components, context, redux, bootstrap, dom and API handling.",
      github: "https://github.com/IsuruPabasara/React-App-Muppala-Course.git",
      certificate:
        "https://coursera.org/share/5a0c5c8ba933d1089ba3071005e65856",
      img1url: "images/portfolio/react-1.png",
      img2url: "images/portfolio/react-2.png",
    },
  ],
  outreach: [
    {
      description: "Committee member",
      institution: "Electronic Club , of University of Moratuwa",
      name: "2019 - 2020",
    },
    {
      description: "Treasurer",
      institution: "IEEE IAS Student Branch, University of Moratuwa",
      name: "2019 - 2020",
    },
    {
      description: "Department Representative",
      institution:
        "Department of Electronic and Telecommunication Engineering, University of Moratuwa",
      name: "2018 - 2019",
    },
    {
      description: "Rotoractor",
      institution: "Rotoract Club University of Moratuwa Student Branch",
      name: "2017 - 2019",
    },
  ],
};

export default resumeData;
